export default "__VITE_ASSET__CTeJohtc__"